import './bottons.css';

const Bottons  = () => {

      return (
            <div className="botton_content">
                  <div className="container botton">
                        <div className="botton_card">
                              <img src="https://i.postimg.cc/bvhbqTbw/a-gcontrol-30.png" alt="Ids" />
                              <strong>Ids</strong>
                        </div>
                        <div className="botton_card">
                              <img src="https://i.postimg.cc/qvnyfYNF/a-goldstar-30.png" alt="Xats" />
                              <strong>Xats And Days</strong>
                        </div>
                        <div className="botton_card">
                              <img src="https://i.postimg.cc/V67bBPhJ/a-allpowers-30.png" alt="Powers" />
                              <strong>Powers</strong>
                        </div>
                  </div>
            </div>
      )
}

export default Bottons;